<div style="text-align: center; padding: 24px;">
  <app-icon iconName="404" style="display: inline-block; width: 300px; height: 300px;"></app-icon>
  <div style="margin-top: 24px;">
    <p style="font-size: 48px; font-weight: 600; margin-bottom: 12px;">404</p>
    <p style="margin-bottom: 12px;">抱歉，您访问的页面不存在</p>
    <button nz-button nzType="primary" style="margin-bottom: 12px;" (click)="back($event)">返回首页</button>
  </div>
</div>